import AnchorLink from '../anchor/anchor-link.vue';
export default AnchorLink;



// WEBPACK FOOTER //
// ./src/components/anchor-link/index.js